import { TimelineModel } from '../../shared/models/timeline.model';

export const MergeDuplicateAccountTimelines: TimelineModel[] = [
    {
        title: 'Select Preferred Account',
        description: 'Select the account you would like to keep moving forward.',
        step: 1,
        state: 'inactive',
        previousTitle: '',
        mobileNote: 'STEP 1',
        data: {},
    },
    {
        title: 'Move Account Balance',
        description: '',
        step: 2,
        state: 'inactive',
        previousTitle: 'Select Preferred Account',
        mobileNote: 'STEP 2',
        data: {},
    },
    {
        title: 'Move Beneficiaries',
        description: '',
        step: 3,
        state: 'inactive',
        previousTitle: 'Move Account Balance',
        mobileNote: 'STEP 3',
        data: {},
    },
    {
        title: 'Export Account Statement',
        description: '',
        step: 4,
        previousTitle: 'Move Beneficiaries',
        state: 'inactive',
        mobileNote: 'STEP 4',
        isFinalStep: true,
        data: {},
    },
];

export enum MergeDuplicateAccountsStep {
    SELECT_PREFERRED_ACCOUNT = 1,
    MOVE_ACCOUNT_BALANCE,
    MOVE_BENEFICIARIES,
    EXPORT_STATEMENT,
    PROFILE_UPDATED,
}

export interface MergeDuplicateAccounts {
    responseCode: string;
    domain: string[];
    name: string;
    description: string;
    data: MergeAccountData;
    type: string;
    identityNumber?: string;
    breadCrumbs?: MergeAccountProfileBreadCrumb;
}
export interface MergeAccountData {
    currentProfile: CurrentProfile;
    duplicateProfile: DuplicateProfile;
    selectedAccount?: string;
    allowSelection: boolean;
    fromAccount: CurrentProfile | DuplicateProfile;
    toAccount: CurrentProfile | DuplicateProfile;
    isDifferentDomainProfile: boolean;
}
export interface DuplicateProfile {
    nubanAccountNumber: string;
    businessName: string;
    businessCategory?: any;
    domain: string;
    accountBalance: number;
    phoneNumber: string;
    email: string;
    username: string;
    numberOfOtherAccounts: number;
    preferred: boolean;
    isSelected: boolean;
    passcodeEnabled?: boolean;
    initials: string;
    profileImage: string;
    pendingKycId?: number;
    livenessVerificationIdentitySource?: string;
}
export interface CurrentProfile {
    nubanAccountNumber: string;
    businessName: string;
    businessCategory: string;
    domain: string;
    accountBalance: number;
    phoneNumber: string;
    email: string;
    username: string;
    numberOfOtherAccounts: number;
    preferred: boolean;
    isSelected: boolean;
    passcodeEnabled?: boolean;
    initials: string;
    profileImage: string;
    pendingKycId?: number;
    livenessVerificationIdentitySource?: string;
}

export enum MergeAccountDomain {
    BUSINESS = 'BUSINESS',
    PERSONAL = 'PERSONAL',
}

export enum MergeDuplicateProfileAccountErrorCode {
    BVN = '400264', //duplicate
    NIN = '400265', //duplicate NIN
}

export interface MergeAccountProfileBreadCrumb {
    uprageKYCLevel2: UprageKYCLevel2;
    brmUprageKYCLevel2: UprageKYCLevel2;
    boDashboard: UprageKYCLevel2;
    brmDashboard: UprageKYCLevel2;
}
interface UprageKYCLevel2 {
    title: string;
    url: string;
}

export interface MergeAccountProfileDuplicateProfileRequest {
    preferredUsername: string;
    unwantedUsername: string;
    preferredPersonalAccount?: string;
    unwantedPersonalAccount?: string;
}
